import { render, staticRenderFns } from "./responseEdit.vue?vue&type=template&id=206afade&scoped=true"
import script from "./responseEdit.vue?vue&type=script&lang=js"
export * from "./responseEdit.vue?vue&type=script&lang=js"
import style0 from "./responseEdit.vue?vue&type=style&index=0&id=206afade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206afade",
  null
  
)

export default component.exports